import React, { useState } from "react";
import ReactModal from "react-modal";
import formImage from "../../../Assets/formImage.png";
import caret_down from "../../../Assets/caret-down.png";
import checkmark_circle from "../../../Assets/checkmark_circle.png";

const AutoDeleteModal = ({
  isOpen,
  onClose,
  responseSetting,
  setResponseSetting,
}) => {
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      borderRadius: "15px",
      transform: "translate(-50%, -50%)",
      width: "40%",
      height: "85%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "Space-between",
      gap: "2rem",
      backgroundColor: "#ffffff",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
    },
  };
  const [openTimePriod, setTimePriod] = useState(false);
  const [openFinalShow, setFinalShow] = useState(false);
  const timePriod = [
    { label: "Disable", value: { hours: 0, days: 0, minutes: 0 } },
    { label: "3 min", value: { hours: 0, days: 0, minutes: 3 } },
    { label: "2 hour", value: { hours: 2, days: 0, minutes: 0 } },
    { label: "6 hour", value: { hours: 6, days: 0, minutes: 0 } },
    { label: "1 day", value: { hours: 0, days: 1, minutes: 0 } },
    { label: "3 day", value: { hours: 0, days: 3, minutes: 0 } },
    { label: "7 day", value: { hours: 0, days: 7, minutes: 0 } },
    { label: "30 day", value: { hours: 0, days: 30, minutes: 0 } },
    { label: "90 day", value: { hours: 0, days: 90, minutes: 0 } },
  ];
  // Function to calculate the adjusted date and time
  const calculateDateTime = ({ days, hours, minutes }) => {
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + days); // Add days
    currentDate.setHours(currentDate.getHours() + hours); // Add hours
    currentDate.setMinutes(currentDate.getMinutes() + minutes);
    return currentDate.toLocaleString(); // Return ISO string (includes both date and time)
  };
  const handelDeleteResponseTime = (time) => {
    if (time.label === "Disable") {
      setResponseSetting({
        ...responseSetting,
        autoDeleteResponseTime: { label: time.label, date: "" },
        autoDeleteResponse: false,
      });
    } else {
      const selectedDate = calculateDateTime(time.value);

      console.log(`Calculated date: ${new Date(selectedDate)}`);
      setResponseSetting({
        ...responseSetting,
        autoDeleteResponseTime: {
          label: time.label,
          date: new Date(selectedDate),
        },
      });
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      style={customStyles}
    >
      <div className="autoDeleteMOdal-container">
        <div className="autodelete-heading-container">
          <div className="heading">Auto-Delete Submissions</div>
          <div className="des">
            Delete existing and new form submissions after a certain period of
            time
          </div>
          <hr style={{ marginTop: "1rem" }} />
        </div>
        <div className="selected-form-details-container">
          <img src={formImage} alt="formimage" />
          <div className="form-details-container-namedeatils">
            <div className="form-details-name">Survey form</div>
            <div className="form-details-details">
              0 Submissions. Modified on Feb 29, 2024.
            </div>
          </div>
        </div>
        {openFinalShow ? (
          <div className="update-final-settings">
            <div className="update-final-setting-head">
              Update your settings?
            </div>
            <div
              style={{
                display: "flex",
                gap: "0.71rem",
                color: "#8493B2",
                fontSize: "0.8rem",
              }}
            >
              <img src={checkmark_circle} alt="checkmark_circle" /> Auto-delete
              submissions {responseSetting.autoDeleteResponseTime.label} after
              they're received.
            </div>
            <div
              style={{
                display: "flex",
                gap: "0.71rem",
                color: "#8493B2",
                fontSize: "0.8rem",
              }}
            >
              <img src={checkmark_circle} alt="checkmark_circle" /> New
              submissions will be deleted 
              {responseSetting.autoDeleteResponseTime.label} after
              they're received.
            </div>
          </div>
        ) : (
          <div className="deletetion-period-container">
            <div>Deletion Period</div>
            <div
              className="deletetion-container-input"
              onClick={() => setTimePriod(!openTimePriod)}
            >
              <div>
                {responseSetting.autoDeleteResponseTime === null
                  ? "Disable"
                  : responseSetting.autoDeleteResponseTime.label}
              </div>
              <img src={caret_down} alt="caret-down" />
              {openTimePriod && (
                <div className="dropdown-time-container">
                  {timePriod.map((time, i) => (
                    <div
                      className="dropdown-time-items-list"
                      key={i}
                      onClick={() =>
                        // setResponseSetting({
                        //   ...responseSetting,
                        //   autoDeleteResponseTime: time,
                        // })
                        handelDeleteResponseTime(time)
                      }
                    >
                      {time.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {openFinalShow ? (
        <div className="bottom-bar-status" style={{ margin: "0" }}>
          <button onClick={() => setFinalShow(false)} className="buttons cbtn">
            Back
          </button>

          <button
            onClick={onClose}
            className="buttons sbtn"
            style={{ padding: "0.71rem 1.21rem" }}
          >
            Yes, Update
          </button>
        </div>
      ) : (
        <div className="bottom-bar-status" style={{ margin: "0" }}>
          <button onClick={onClose} className="buttons cbtn">
            Cancel
          </button>
          <button
            onClick={() => setFinalShow(true)}
            className="buttons sbtn"
            style={{ padding: "0.71rem 1.21rem" }}
          >
            Next
          </button>
        </div>
      )}
    </ReactModal>
  );
};

export default AutoDeleteModal;
